import axiosClient from "./axiosClient";

const url = "/users";

export const userApi = {
  getAll(params) {
    return axiosClient.get(url, { params });
  },
  getById(id) {
    return axiosClient.get(`${url}/${id}`);
  },
  create(body) {
    return axiosClient.post(url, body);
  },
  update(payload) {
    const { _id, ...body } = payload;
    return axiosClient.put(`${url}/${_id}`, body);
  },
  remove(id) {
    return axiosClient.delete(`${url}/${id}`);
  },
  adminChangePassword(id, body) {
    return axiosClient.put(`${url}/${id}/admin-change-password`, body);
  },
};
